export default __webpack_public_path__ + "static/media/download.9597c32f.svg";